import { render, staticRenderFns } from "./ApplicationDetailInfo.vue?vue&type=template&id=45d73ac6&scoped=true&"
import script from "./ApplicationDetailInfo.vue?vue&type=script&lang=js&"
export * from "./ApplicationDetailInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d73ac6",
  null
  
)

export default component.exports